import apiClient from "@/api/client";
import type { CourierRequest } from "../types";

export const couriersApi = {
  list: (params?: Record<string, string>) =>
    apiClient
      .get<{ data: CourierRequest[] }>("/courier-requests/", { params })
      .then((r) => r.data.data),

  get: (id: string) =>
    apiClient
      .get<{ data: CourierRequest }>(`/courier-requests/${id}/`)
      .then((r) => r.data.data),

  create: (data: {
    delivery_type: string;
    pickup_address: string;
    size: string;
    recipient_address: string;
    notes?: string;
    requested_at?: string;
  }) =>
    apiClient
      .post<{ data: CourierRequest }>("/courier-requests/", data)
      .then((r) => r.data.data),

  update: (id: string, data: Partial<CourierRequest>) =>
    apiClient
      .patch<{ data: CourierRequest }>(`/courier-requests/${id}/`, data)
      .then((r) => r.data.data),

  delete: (id: string) => apiClient.delete(`/courier-requests/${id}/`),

  order: (id: string, data: { ordered_at?: string; ordered_for?: string; label_file?: File }) => {
    const form = new FormData();
    if (data.ordered_at) form.append("ordered_at", data.ordered_at);
    if (data.ordered_for) form.append("ordered_for", data.ordered_for);
    if (data.label_file) form.append("label_file", data.label_file);
    return apiClient
      .post<{ data: CourierRequest }>(`/courier-requests/${id}/order/`, form, {
        headers: { "Content-Type": "multipart/form-data" },
      })
      .then((r) => r.data.data);
  },

  reject: (id: string, data?: { notes?: string }) =>
    apiClient
      .post<{ data: CourierRequest }>(`/courier-requests/${id}/reject/`, data ?? {})
      .then((r) => r.data.data),

  reopen: (id: string) =>
    apiClient
      .post<{ data: CourierRequest }>(`/courier-requests/${id}/reopen/`, {})
      .then((r) => r.data.data),

  markReceived: (id: string) =>
    apiClient
      .post<{ data: CourierRequest }>(`/courier-requests/${id}/mark-received/`, {})
      .then((r) => r.data.data),

  cancel: (id: string) =>
    apiClient
      .post<{ data: CourierRequest }>(`/courier-requests/${id}/cancel/`, {})
      .then((r) => r.data.data),

  pendingCount: () =>
    apiClient
      .get<{ data: number }>("/courier-requests/pending-count/")
      .then((r) => r.data.data),
};
